import { Page } from "../translations/types";
import { VIEW_FORM_FIELDS_TRANSLATIONS } from "../translations/util";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_FAULTS_FORM_FIELDS: any = [
  {
    name: "ROW-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FAULTS]["ROW-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FAULTS]["EVENT-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "VERSION",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FAULTS].VERSION,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "INSTANCE",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FAULTS].INSTANCE,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "CreatedAt",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FAULTS].CreatedAt,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "HOSTNAME",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FAULTS].HOSTNAME,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "ADDITIONAL-INFO",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FAULTS]["ADDITIONAL-INFO"],
    truncate: false,
    hasCopyButton: true,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_P25_GROUP_FORM_FIELDS: any = [
  {
    name: "Ref",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP].Ref,
    truncate: true,
    hasCopyButton: true,
  },
  {
    name: "TARGET-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP]["TARGET-ID"].label,
    tooltipText:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP]["TARGET-ID"].tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "HOSTNAME",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP].HOSTNAME,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "PERIOD",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP].PERIOD,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "RFSS",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP].RFSS.label,
    tooltipText: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP].RFSS.tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "MONITOR",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].MONITOR,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "CreationDate",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP].CreationDate,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "ModificationDate",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_GROUP].ModificationDate,
    truncate: false,
    hasCopyButton: false,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_FIXED_NETWORK_ELEMENT_FORM_FIELDS: any = [
  {
    name: "Ref",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].Ref,
    truncate: true,
    hasCopyButton: true,
  },
  {
    name: "TARGET-ID",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT]["TARGET-ID"]
        .label,
    tooltipText:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT]["TARGET-ID"]
        .tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "PERIOD",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].PERIOD,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "RFSS",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].RFSS.label,
    tooltipText:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].RFSS
        .tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "MONITOR",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].MONITOR,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "CreationDate",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].CreationDate,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "ModificationDate",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT]
        .ModificationDate,
    truncate: false,
    hasCopyButton: false,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_INSTANCE_FORM_FIELDS: any = [
  {
    name: "ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INSTANCE].ID,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "ENGINE-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INSTANCE]["ENGINE-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "HOSTNAME",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INSTANCE].HOSTNAME,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "INSTANCE",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INSTANCE].INSTANCE,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "STARTED-AT",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INSTANCE]["STARTED-AT"],
    truncate: false,
    hasCopyButton: true,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_INVENTORY_FORM_FIELDS: any = [
  {
    name: "EVENT-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-NAME",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-NAME"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-PERCEIVED-SEVERITY",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-PERCEIVED-SEVERITY"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-SYMPTOMS",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-SYMPTOMS"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "SOURCE-COMPONENT",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["SOURCE-COMPONENT"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "INHIBITED-AT",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["INHIBITED-AT"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "ALARM-TYPE",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["ALARM-TYPE"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "CreatedAt",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY].CreatedAt,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-DESCRIPTION",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-DESCRIPTION"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-PROBABLE-CAUSE",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-PROBABLE-CAUSE"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-RESOLUTION",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-RESOLUTION"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-SPECIFIC-PROBLEM",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-SPECIFIC-PROBLEM"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-TYPE",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["EVENT-TYPE"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "SOURCE-APPLICATION",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.INVENTORY]["SOURCE-APPLICATION"],
    truncate: false,
    hasCopyButton: true,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_HISTORICAL_ALARMS_FORM_FIELDS: any = [
  {
    name: "ROW-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM]["ROW-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "EVENT-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM]["EVENT-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "NOTIFICATION-ID",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM]["NOTIFICATION-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "ROW-TYPE",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM]["ROW-TYPE"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "VERSION",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM].VERSION,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "INSTANCE",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM].INSTANCE,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "CreatedAt",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM].CreatedAt,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "HOSTNAME",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM].HOSTNAME,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "APP-REF",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM]["APP-REF"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "SUB-COMPONENT",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.HISTORICAL_ALARM]["SUB-COMPONENT"],
    truncate: false,
    hasCopyButton: true,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_ALARMS_FORM_FIELDS: any = [
  {
    name: "EVENT-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM]["EVENT-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "VERSION",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM].VERSION,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "INSTANCE",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM].INSTANCE,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "CreatedAt",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM].CreatedAt,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "HOSTNAME",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM].HOSTNAME,
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "NOTIFICATION-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM]["NOTIFICATION-ID"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "APP-REF",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM]["APP-REF"],
    truncate: false,
    hasCopyButton: true,
  },
  {
    name: "SUB-COMPONENT",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.ACTIVE_ALARM]["SUB-COMPONENT"],
    truncate: false,
    hasCopyButton: true,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_P25_UNIT_FORM_FIELDS: any = [
  {
    name: "Ref",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].Ref,
    truncate: true,
    hasCopyButton: true,
  },
  {
    name: "TARGET-ID",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT]["TARGET-ID"].label,
    tooltipText:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT]["TARGET-ID"].tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "PERIOD",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].PERIOD,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "RFSS",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].RFSS.label,
    tooltipText: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].RFSS.tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "MONITOR",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].MONITOR,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "CreationDate",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].CreationDate,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "ModificationDate",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_UNIT].ModificationDate,
    truncate: false,
    hasCopyButton: false,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VIEW_P25_AFFILIATIONS_FORM_FIELDS: any = [
  {
    name: "Ref",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS].Ref,
    truncate: true,
    hasCopyButton: true,
  },
  {
    name: "TARGET-ID",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS]["TARGET-ID"].label,
    tooltipText:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS]["TARGET-ID"]
        .tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "PERIOD",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS].PERIOD,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "RFSS",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS].RFSS.label,
    tooltipText:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS].RFSS.tooltipText,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "CreationDate",
    label: VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS].CreationDate,
    truncate: false,
    hasCopyButton: false,
  },
  {
    name: "ModificationDate",
    label:
      VIEW_FORM_FIELDS_TRANSLATIONS[Page.P25_AFFILIATIONS].ModificationDate,
    truncate: false,
    hasCopyButton: false,
  },
];
